import {
  Directive,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { BehaviorSubject, merge, Observable, Subject } from 'rxjs';
import { distinctUntilChanged, map, scan, takeUntil } from 'rxjs/operators';
import {
  UrlQuery,
  UrlQueryFilter,
  URL_QUERY,
} from '../core/url-query.directive';
import { async } from '../rx/util';
import { ModalKey, ModalService } from './modal.service';

export function subject() {
  return new BehaviorSubject(undefined);
}

@Directive({
  selector: '[modalUrlQuery]',
  providers: [UrlQueryFilter, { provide: URL_QUERY, useFactory: subject }],
})
export class ModalUrlQueryDirective implements OnDestroy, OnInit {
  private readonly destroy = new Subject();

  private readonly manageModal: Observable<ModalKey | undefined> = merge(
    this.urlQueryFilter.matches,
    this.destroy.pipe(
      map(() => {
        return false;
      }),
    ),
  ).pipe(
    distinctUntilChanged(),
    scan<boolean, ModalKey | undefined>((key, show) => {
      if (show) {
        return this.modalService.addModal(this.template);
      } else if (key != null) {
        this.modalService.removeModal(key);
      }
    }, undefined),
  );

  constructor(
    @Inject(URL_QUERY) private readonly urlQuery_: Subject<UrlQuery>,
    private readonly modalService: ModalService,
    private readonly template: TemplateRef<any>,
    private readonly urlQueryFilter: UrlQueryFilter,
  ) {}

  ngOnInit() {
    this.manageModal.pipe(takeUntil(this.destroy.pipe(async()))).subscribe();
  }

  @Input()
  set modalUrlQuery(value: { [key: string]: string | undefined }) {
    this.urlQuery_.next(value);
  }

  ngOnDestroy() {
    this.destroy.next(undefined);
  }
}
